(function ($) {

    "use strict";

    $( window ).on( "load", function(){
    
        window.sr = ScrollReveal();

        sr.reveal('.reveal-0', {
            delay: 0,
            duration: 500,
            distance: '100px',
            scale: 1,
            mobile: false
        });
        sr.reveal('.reveal-1', {
            delay: 100,
            duration: 600,
            distance: '100px',
            scale: 1,
            mobile: false
        });
        sr.reveal('.reveal-2', {
            delay: 200,
            duration: 800,
            distance: '100px',
            scale: 1,
            mobile: false,
            afterReveal: resetLines
        });

        sr.reveal('.subReveal', {
            delay: 400,
            duration: 500,
            distance: '100px',
            scale: 1,
            afterReveal: visibleEl,
            mobile: false
        }, 150);
    });

    function visibleEl(){
        $('.subReveal').css('overflow-y', 'initial');
    }

    function resetLines(){
        var combinedHTML = "";
        $(".main_visual-block .do-reveal").each(function () {
            combinedHTML += $(this).html();
        });

        $(".do-reveal").not(':first').remove();
        $(".do-reveal").html(combinedHTML);
    }

})(jQuery);